import { render, staticRenderFns } from "./YieldBoxPlotController.vue?vue&type=template&id=3aaeb00c&"
import script from "./YieldBoxPlotController.vue?vue&type=script&lang=ts&"
export * from "./YieldBoxPlotController.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports